import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { Dokter, Unit } from "@/types";
import DataResepFarmasi from "@/services/DataResepFarmasi";
import ResepObatSvc from "@/services/ResepObat";
import moment from "moment";

interface ResepRaw {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  jenis_resep: number;
  // dr_id: number;
  dokter: Dokter;
  // unit_id: string;
  unit: Unit;
  // pasien_cm: number;
  pasien: object;
  register_id: number;
  status: number;
  tanggal: string;
  items: ResepItems[];
  resep_racikan?: [];
  created_at: string;
}

interface Resep {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  jenis_resep: number /* 1: reguler; 2: terjadwal; 3: cito; 4: pulang */;
  // dr_id: number;
  dokter: Dokter;
  // unit_id: string;
  unit: Unit;
  // pasien_cm: number;
  pasien: object;
  register_id: number;
  status: number;
  tanggal: string;
  items: ResepItems[];
  created_at: string;
}

interface ResepItems {
  id: 191;
  obat_id: string;
  obat_nama: string;
  qty: 10;
  qty_unit: string;
  harga: number;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: number;
  ap_template_nama: string;
  // aturan_pakai: { id: null; nama: "" };
  frekuensi_id?: string;
  rute_id?: string;
  frekuensi: { id: string; nama: string };
  rute: { id: string; nama: string };
  r: string;
  stopped_at: string;
}

@Module({ store, dynamic: true, name: "resepStore", namespaced: true })
class ResepStore extends VuexModule {
  public resepRaw: Array<ResepRaw> = [];
  public listLoading = false;
  public inputText = "";
  public inputResepMode = false;
  public depoId: string = null;

  public get resep(): Resep[] {
    const resep = this.resepRaw.map(raw => {
      if (Object.hasOwnProperty.call(raw, "resep_racikan")) {
        const { resep_racikan, ...restResep } = raw;

        // @ts-ignore
        restResep.items = [...restResep.items, ...resep_racikan];

        return restResep;
      } else {
        return raw;
      }
    });

    return resep;
  }

  public get resepTerjadwal(): Resep[] {
    return this.resep.filter(item => item.jenis_resep == 2);
  }

  public get anyResepTerjadwalToday(): Resep[] {
    return this.resepTerjadwal.filter(
      item => item.tanggal == moment().format("YYYY-MM-DD")
    );
  }

  public get anyResepPulang(): Resep {
    return this.resep.find(
      item =>
        item.tanggal <= moment().format("YYYY-MM-DD") && item.jenis_resep == 4
    );
  }

  @Mutation
  public SET_RESEP(data: Array<ResepRaw>): void {
    this.resepRaw = data;
  }

  @Mutation
  public SET_LIST_LOADING(data: boolean): void {
    this.listLoading = data;
  }

  @Mutation
  public SET_INPUT_TEXT(text: string): void {
    this.inputText = text;
  }

  @Mutation
  public SHOW_INPUT_RESEP(): void {
    this.inputResepMode = true;
  }

  @Mutation
  public HIDE_INPUT_RESEP(): void {
    this.inputResepMode = false;
  }

  @Mutation
  public RESET_ALL(): void {
    this.resepRaw = [];
    this.inputText = "";
  }

  @Mutation
  public SET_LIST_TRANSL_IF(text: string): void {
    this.inputText = text;
  }

  @Mutation
  public SET_DEPO_ID(depoId: string): void {
    this.depoId = depoId;
  }

  @Action
  public setResep(data: Array<ResepRaw>): void {
    this.SET_RESEP(data);
  }

  @Action
  public showInputResep(): void {
    this.SHOW_INPUT_RESEP();
  }

  @Action
  public hideInputResep(): void {
    this.HIDE_INPUT_RESEP();
  }

  @Action act_list_trans_farmasi(reg) {
    const dt = DataResepFarmasi.getDataListTransaksi(reg);
    dt.then(dt => {
      const listFarmasi = dt.data;
      this.SET_LIST_TRANSL_IF(listFarmasi);
    });
  }

  @Action reset() {
    this.RESET_ALL();
  }

  @Action getResepByRegister(reg) {
    this.SET_LIST_LOADING(true);

    return ResepObatSvc.getByRegister(reg)
      .then(resp => {
        this.SET_RESEP(resp.data.data);
      })
      .finally(() => {
        this.SET_LIST_LOADING(false);
      });
  }

  @Action
  public setDepoId(depoId: string): void {
    this.SET_DEPO_ID(depoId);
  }
}

export const resepStore = getModule(ResepStore);
